class OrderAdditionalForm {
  order_no= ''

  name = ''

  sex = 1

  phone = ''

  region = ''

  address = ''

  id_number = ''

  id_number_photo = ''

  driving_photo = ''

  /**
   * 设置属性
   * @param  Object  obj  属性对象, 如: {id: 10001}
   * @return Class   this
  */
  setData (obj = {}) {
    Object.keys(obj).forEach((k) => {
      if (typeof obj[k] !== 'function') this[k] = obj[k]
    })
    return this
  }

  // 合法校验
  invalid () {
    if (!this.name) return '请填写姓名'
    if (this.name.length < 2) return '请填写正确的姓名'
    if (!this.phone) return '请填写手机号'
    if (this.phone.length < 11) return '请填写正确的手机号'
  }
}

export default OrderAdditionalForm
